import { render } from "./Compose.vue?vue&type=template&id=4e218180"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__